@if (viewMode === 'select') {
    <div #trigger class="ui-partner-select-container ui-secondary" [ngClass] = "{'ui-partner-selected': selectedPartner, 'ui-partner-selected-view': readonly, 'ui-partner-select-loading': isLoading}" (click)= "eventOpenOptions()">
        @if (isLoading) {
            <div class = "ui-select-icon" skeletonLoaderPipe = "circle"></div>
            <div class = "ui-detail-container">
                <span class="ui-title" skeletonLoaderPipe = "rect">Carregando...</span>
                <span class="ui-sub-title" skeletonLoaderPipe = "rect">Carregando...</span>
                <span class="ui-label" skeletonLoaderPipe = "rect">{{ label }}</span>
            </div>
        } @else if (selectedPartner) {
            <div class = "ui-select-icon">
                <img [src] = "selectedPartner.logoSrc" width="100%" height="100%" style="object-fit: contain;">
            </div>
            <div class = "ui-detail-container">
                <span class="ui-title">{{ selectedPartner.name }}</span>
                <span class="ui-sub-title">
                    {{ selectedPartner.detail.document.number | mask: selectedPartner.detail.document.number.length ? '000.000.000-00' : '99.999.999/9999-99'}}
                </span>
                <span class="ui-label">{{ label }}</span>
                @if (!readonly) {
                    <button class = "ui-button">
                        <span class = "ui-button-label">alterar</span>
                    </button>
                }
            </div>
        } @else if (!readonly) {
            <div class = "ui-detail-container">
                <span class="ui-title">Selecione o {{ label }}</span>
            </div>
        } @else if (readonly) {
            <div class = "ui-select-icon">
                <i class = "{{ icon }}"></i>
            </div>
            <div class = "ui-detail-container">
                <span class="ui-title">{{ label }}</span>
                <span class="ui-sub-title">Não vinculado</span>
            </div>
        }
    </div>

    <ng-template #dropdownTemplate>
        <div class = "ui-select-menu">
            <div class = "ui-field ui-secondary ui-field-without-border">
                <i class = "ui-icon uii-search"></i>
                <input type="text" class="ui-select-menu-search-input" placeholder="Buscar parceiro..." (input)="eventPartnerFilterChange($event)"/>
            </div>

            <div class = "ui-select-options" [ngClass] = "{ 'ui-select-searching-options': searching }">
                @for (partner of partners; track partner._id) {
                    <div class="ui-select-option" (click)="eventPartnerChanged(partner)">
                        <div class = "ui-select-icon">
                            <img [src] = "partner.logoSrc" width="100%" height="100%" style="object-fit: contain;">
                        </div>
                        <div>
                            <div class = "ui-title">
                                {{ partner.name }}
                            </div>
                            <span class = "ui-sub-title">
                                {{ partner.detail.document.number | mask: partner.detail.document.number.length ? '000.000.000-00' : '99.999.999/9999-99'}}
                            </span>
                        </div>
                    </div>
                }
                @if (partners.length === 0) {
                    <div class = "ui-empty-container">
                        Nenhum parceiro encontrado
                    </div>
                }
            </div>
        </div>
    </ng-template>
} @else {
    <div class = "ui-partner-select-badge-container">
        <div class = "ui-field">
            <i class = "ui-icon uii-search"></i>
            <input type = "text" placeholder = "Pesquisar..." (input)="eventPartnerFilterChange($event)">
        </div>
        <div class = "ui-partners-container">
            @if (!isLoading) {
                @for (partner of partners.slice(0, 4); track partner._id) {
                    <div class = "ui-badge" (click)="eventPartnerChanged(partner)" [ngClass] = "{'ui-badge-active': selectedPartner?._id === partner._id}">{{ partner.name }}</div>
                }
            } @else {
                <div class = "ui-badge" skeletonLoaderPipe = "rect">
                    Bucando
                </div>
                <div class = "ui-badge" skeletonLoaderPipe = "rect">
                    Bucando
                </div>
            }
        </div>
    </div>
}
